import saveVisitor from '../api/visitors/saveVisiter';

export async function getIPAddress() {
    try {
        const response = await fetch('https://api4.ipify.org?format=json');
        const data = await response.json();
        return data.ip;
    } catch (error) {
        console.error("Error fetching IP address:", error);
        return "Unknown IP";
    }
}

export function getBrowserName() {
    const userAgent = navigator.userAgent;
    if (userAgent.includes("Firefox")) return "Firefox";
    if (userAgent.includes("Edg")) return "Edge";
    if (userAgent.includes("Chrome") && !userAgent.includes("Edg")) return "Chrome";
    if (userAgent.includes("Safari") && !userAgent.includes("Chrome")) return "Safari";
    if (userAgent.includes("Opera") || userAgent.includes("OPR")) return "Opera";
    return "Unknown";
}

export function getOSName() {
    const userAgent = navigator.userAgent;
    if (userAgent.includes("Windows")) return "Windows";
    if (userAgent.includes("Mac")) return "Mac";
    if (userAgent.includes("Linux")) return "Linux";
    if (userAgent.includes("Android")) return "Android";
    if (userAgent.includes("iOS") || userAgent.includes("iPhone")) return "iOS";
    return "Unknown";
}

export async function trackVisitor() {
    const visitorData = {
        visitor_id: localStorage.getItem("visitor_id") || crypto.randomUUID(),
        ip_address: await getIPAddress(),
        device: getOSName(),
        browser: getBrowserName(),
        screen_resolution: `${window.screen.width}x${window.screen.height}`,
        referrer: document.referrer || "Direct Visit",
        page_visited: window.location.href,
        visit_time: new Date().toISOString()
    };

    localStorage.setItem("visitor_id", visitorData.visitor_id);

    try {
        const [, res] = await saveVisitor(visitorData);
    } catch (error) {
        console.error("Error tracking visitor:", error);
    }
}